var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="rgs-adaptive-table-icon-sorting"> <i class="fa"data-bind="css: {\n			\'fa-sort\': mode() === \'default\',\n			\'fa-sort-down\': mode() === \'asc\',\n			\'fa-sort-up\': mode() === \'desc\',\n			\'rgs-adaptive-table-icon-sorting-active\': mode() === \'asc\' || mode() === \'desc\',\n			\'rgs-adaptive-table-icon-sorting-inactive\': mode() === \'default\'\n		}"></i> </div>';
}
return __p;
};
